<template>
  <div>

    <z-container bottom="0">
      <v-row>

        <!-- <v-col cols="12" align="center">
          <v-avatar color="primary" size="90">
            <v-icon size="50" dark>mdi-briefcase</v-icon>
          </v-avatar>
        </v-col> -->

        <v-col cols="12">
          <h1 class=" font-weight-light mb-0">
            Bem-vindo ao <span class="font-weight-bold">Sistema Gerencial</span>
          </h1>
          <p class="overline" style="font-size: 12px !important">
            Controle de Estoque e pedidos de venda.
          </p>
        </v-col>
      </v-row>

      <!-- <v-scroll-y-transition mode='out-in'>
        <v-row justify="center" v-show="quantidadeEstoqueMinimo > 0">
          <v-col cols="12">
            <v-alert color="error" text prominent icon="work" class="text-center">
              <div>Atenção!</div>
              <span>O sistema apresenta <b>{{quantidadeEstoqueMinimo}}</b> produtos com o estoque abaixo do mínimo. Clique <a class="red--text sublinhado" @click.prevent="relatorioEstoqueMinimo">aqui</a> para ver o relatório.</span>
            </v-alert>
          </v-col>
        </v-row>
      </v-scroll-y-transition> -->


    </z-container>
  </div>

</template>

<script>
import config from '@/app/config';

export default {
  name: 'BemVindo',

  data: () => ({
    msg_minimo: false,
    produtos_com_estoque_minimo: 0,
    dashboard: {},
    loading: false,
  }),

  methods: {
    relatorioEstoqueMinimo() {
      this.abrirJanela(config.BASE_URL_PRINT + '/produtos/imprimir?impressao=estoqueminimo&ordenar_por=referencia&estoquezerado=0');
    },
  },

  computed: {
    quantidadeEstoqueMinimo() {
      return this.$store.state.produtos.quantidade_produtos_estoque_minimo;
    }
  },
};
</script>

<style>
  .sublinhado {
    text-decoration: underline;
  }
</style>